export var AgentCategory;
(function (AgentCategory) {
    AgentCategory["Work"] = "work";
    AgentCategory["Personal"] = "personal";
    AgentCategory["Collaboration"] = "collaboration";
})(AgentCategory || (AgentCategory = {}));
//# sourceMappingURL=agent-category.const.js.map